import {
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { $crud } from "../../utils/CrudFactory";
import { usePagination } from "../../hooks";
import DynamicTable from "../../components/DynamicTable";
import DashboardTable from "../../components/NewTable/DashboardTable";
import { orderFilters, regularOfferFilters } from "../../utils/filterConfig";
import {
  Visibility,
  VisibilityOff,
  EditNote,
  Delete,
} from "@mui/icons-material";
import RegularOfferModal from "../../components/modals/RegularOfferModal";
import Filter from "../../components/Filter";
import { timetoUTC, toLocalTime } from "../../helper/functions";
import RegularOfferFIlter from "../../components/filters/RegularOfferFIlter";

export default function RegularOffers() {
  const theme = useTheme();
  const navigate = useNavigate();
  const [expandedRows, setExpandedRows] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openRegularOfferModal, setOpenRegularOfferModal] = useState(false);
  const [rows, setRows] = useState([]); //STATE TO GET THE ORDER LIST
  const [isFilter, setIsFilter] = useState(false); //STATE TO GET THE ORDER LIST
  const { page, limit, setLimit, setPage, total, setTotal } = usePagination(); // PAGINATION PROPS
  const location = useLocation();
  // STATE TO MANAGE FILTERS --------------------------------------
  const [filtrationData, setFiltrationData] = useState({
    startfrom: "",
    startto: "",
    endfrom: "",
    endto: "",
    target: "",
    stage: "",
  });
  // STATE TO MANAGE FILTERS --------------------------------------

  async function retrieveData() {
    const isFilterApplied = Object.values(filtrationData).some(
      (value) => value !== "" && value !== false
    );

    const params = {
      startfrom: timetoUTC(filtrationData.startfrom),
      startto: timetoUTC(filtrationData.startto),
      endfrom: timetoUTC(filtrationData.endfrom),
      endto: timetoUTC(filtrationData.endto),
      target: filtrationData.target,
      stage: filtrationData.stage,
    };

    // Conditionally include limit and page if no filters are applied
    if (!isFilterApplied) {
      params.limit = 0;
      params.page = 0;
    }

    const { data } = await $crud.retrieve("admin/regular-offers", params);
    return data;
  }

  useEffect(() => {
    // RUNNING THE retrieveData() FUNCTION ---------------------------------
    retrieveData().then((res) => {
      setRows(res.result);
      setTotal(res.total);
    });
    // RUNNING THE retrieveData() FUNCTION ---------------------------------
  }, [limit, page, filtrationData]);

  const handleOpenRegularOfferModal = (row) => {
    setSelectedRow(row);
    setOpenRegularOfferModal(true);
  };

  // function to close position modal---------------------------------
  const handleCloseModal = () => {
    setOpenRegularOfferModal(false);
    setSelectedRow(null);
  };

  // function to call the api and update the comment -------------------------------------
  const handleOfferSubmit = async (reason) => {
    // Logic to update position with reason
    const { data, type } = await $crud.put(`admin/regular-offer-archieve`, {
      id: selectedRow._id,
    });
    if (type == "success") {
      retrieveData().then((res) => {
        setRows(res.result);
        setTotal(res.total);
      });
    }
    // handleCloseModal();
  };
  // COLUMNS IN THE ORDER TABLE-----------------------------
  const clientColumns = [
    {
      id: "offerCode",
      label: "Offer Code",
      align: "center",
    },
    {
      id: "stage",
      label: "Stage",
      align: "center",
      renderCell: (row) => {
        const getStatusStyles = (status) => {
          switch (status) {
            case "Active":
              return {
                background: "rgba(7, 79, 36, 0.35)",
              };
            case "Archived":
              return {
                background: "rgba(104, 60, 140, 0.5)",
              };
            case "Expired":
              return {
                background: "rgba(251, 189, 189, 1)",
              };
            default:
              return {
                background: "#FFF0ED",
              };
          }
        };
        const styles = getStatusStyles(row.stage);
        return (
          <Button
            sx={{
              background: styles.background,
              cursor: "auto",
              borderRadius: "22px",
              color: "rgba(23, 26, 31, 1)",
              padding: "7px 27px",
              textTransform: "capitalize",
              border: "none",
              fontSize: "12px",
              width: "100px",
              outline: "none !important",
              "&:hover": {
                outline: styles.background,
                background: styles.background,
              },
              "&:focus": {
                outline: styles.background,
                background: styles.background,
              },
            }}
          >
            {row.stage}
          </Button>
        );
      },
    },
    {
      id: "usedBy",
      label: "Used By",
      align: "center",
    },
    {
      id: "savedValue",
      label: "Saved Value",
      align: "center",
    },
    {
      id: "startDate",
      label: "Start Date",
      align: "center",
      renderCell: (row) => toLocalTime(row.startDate),
    },
    {
      id: "expireDate",
      label: "Expire Date",
      align: "center",
      renderCell: (row) => toLocalTime(row.expireDate),
    },
    {
      id: "action",
      label: "View",
      align: "center",
      renderCell: (row, navigate, handleExpand, expandedId) => {
        const isRowExpanded = expandedId === row._id;
        return (
          <>
            {isRowExpanded ? (
              <IconButton
                sx={{
                  fontSize: "8px",
                  color: "rgba(104, 60, 140, 1)",
                }}
                onClick={() => handleExpand(row._id)}
                // Add your onClick logic for delete here
              >
                <VisibilityOff />
              </IconButton>
            ) : (
              <IconButton
                sx={{ fontSize: "8px", color: "rgba(104, 60, 140, 1)" }}
                onClick={() => handleExpand(row._id)}
              >
                <Visibility />
              </IconButton>
            )}
          </>
        );
      },
    },
    {
      id: "action",
      label: "Archive",
      align: "center",
      renderCell: (row) => {
        const isRowExpanded = expandedRows.includes(row._id);
        return (
          <>
            <IconButton
              sx={{ fontSize: "8px", color: "rgba(104, 60, 140, 1)" }}
              onClick={(e) => handleOpenRegularOfferModal(row)}
            >
              <Delete />
            </IconButton>
          </>
        );
      },
    },
  ];
  // COLUMNS IN THE ORDER TABLE-----------------------------

  const handleExpandRow = (rowId) => {
    setExpandedRows((prev) =>
      prev.includes(rowId)
        ? prev.filter((id) => id !== rowId)
        : [...prev, rowId]
    );
  };

  useEffect(() => {
    if (location.state?.id) {
      setTimeout(() => {
        setExpandedRows((prev) => [...prev, location.state?.id]);
      }, 1000);
    }
  }, [location.state]);

  // FUNCTION TO SET THE FILTERS IN filtrationData STATE -----------------------------
  const getFilteredData = (data) => {
    if (!data.stage) data.stage = "";
    if (!data.target) data.target = "";
    setFiltrationData({
      ...filtrationData,
      ...data,
    });
    setIsFilter(true);
    setPage(0);
  };
  // FUNCTION TO SET THE FILTERS IN filtrationData STATE -----------------------------
  return (
    <>
      <Grid container sx={{ padding: "0 18px" }}>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              fontSize: "30px",
              // color: "#673C8E",
              color: theme.palette.text.primary,
            }}
          >
            Regular Offers
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            paddingRight: "24px",
            display: "flex",
            // flexDirection: "column",
            justifyContent: "end",
            alignItems: "end",
            gap: "15px",
          }}
        >
          <Button
            onClick={() => navigate("add")}
            variant="outlined"
            size="small"
            sx={{
              padding: "10px 30px",
              textTransform: "capitalize",
              backgroundColor: "transparent",
              color: "rgba(103, 60, 142, 1)",
              borderColor: "rgba(103, 60, 142, 1)",
              borderRadius: "4px",
              fontWeight: 600,
              // fontSize: "16px",
              "&:hover": {
                backgroundColor: "transparent",
                color: "rgba(103, 60, 142, 1)",
                borderColor: "rgba(103, 60, 142, 1)",
              },
            }}
          >
            Create New Offer
          </Button>
          <Button
            onClick={() => navigate("/services/help-offers")}
            variant="contained"
            size="small"
            sx={{
              padding: "10px 30px",
              textTransform: "capitalize",
              backgroundColor: "rgba(103, 60, 142, 1)",
              color: "#fff",
              borderRadius: "4px",
              fontWeight: 600,
              // fontSize: "16px",
              "&:hover": {
                backgroundColor: "rgba(103, 60, 142, 1)",
                color: "#fff",
              },
            }}
          >
            Go To Help Offers
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ paddingRight: "24px" }}>
        {/* <DynamicTable
          rows={rows}
          type="regularOffers"
          url="regular-offers"
          setRows={setRows}
          filterConfig={regularOfferFilters} // Pass the filter checkbox options
          noRecordTitle="No regular offers yet !" // no data title
          onFilterData={getFilteredData} // filteration data
          onResetFilters={() => {
            setFiltrationData((prev) => ({
              target: "",
              stage: "",
              from: "",
              to: "",
            }));
            setIsFilter(false);
          }}
          filtrationData={filtrationData}
          isFilter={isFilter}
          onSearchData={(value) =>
            setFiltrationData({ ...filtrationData, search: value })
          }
          paginationProps={{ limit, page, setLimit, setPage, total, setTotal }}
          columns={clientColumns} // Pass the columns prop
          expandedRows={expandedRows}
          handleExpandRow={handleExpandRow}
        /> */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            paddingRight: "18px",
            marginTop: "10px",
          }}
        >
          <Filter
            filtrationData={filtrationData}
            onFilterData={getFilteredData} // filteration data
            onResetFilters={() => {
              setFiltrationData((prev) => ({
                target: "",
                stage: "",
                startfrom: "",
                startto: "",
                endfrom: "",
                endto: "",
              }));
              setIsFilter(false);
            }}
            type="regularOffers"
            url="regular-offers"
            config={regularOfferFilters}
            CustomDate={RegularOfferFIlter}
          />
        </div>
        <DashboardTable
          rows={rows}
          columns={clientColumns}
          emptyMessage="No regular offers yet !"
          renderExpandedRow={(row) => {
            return (
              <Box
                sx={{
                  position: "relative",
                  padding: "0 34px",
                  paddingTop: "34px",
                  paddingBottom: 0,
                  display: "flex",
                  alignItems: "start",
                  justifyContent: "space-between",
                  gap: "20px",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: "4px",
                    right: "36px",
                  }}
                >
                  <IconButton
                    sx={{
                      fontSize: "8px",
                      color: "rgba(104, 60, 140, 1)",
                    }}
                    onClick={() => navigate(`add?id=${row._id}`)}
                    // Add your onClick logic for edit here
                  >
                    <EditNote />
                  </IconButton>
                  {/* <IconButton
                                                sx={{
                                                  fontSize: "8px",
                                                  color: "rgba(104, 60, 140, 1)",
                                                }}
                                                onClick={() => handleExpandRow(row._id)}
                                                // Add your onClick logic for delete here
                                              >
                                                <VisibilityOff />
                                              </IconButton> */}
                </Box>
                <Box>
                  <Box
                    sx={{
                      width: "260px",
                      height: "120px",
                      background: "#673C8E",
                      mb: 1,
                    }}
                  >
                    <img
                      alt=""
                      style={{
                        width: "inherit",
                        height: "inherit",
                      }}
                      src={row.bannerImg}
                    />
                  </Box>
                  <Typography
                    sx={{
                      textAlign: "center",
                      fontSize: "20px",
                      fontWeight: 600,
                      color: "rgba(242, 132, 118, 1)",
                    }}
                  >
                    Offer Preview
                  </Typography>
                </Box>
                <Box>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "150px 10px 1fr",
                      gap: 1,
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#000",
                      }}
                    >
                      Created on
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#000",
                      }}
                    >
                      :
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#000",
                      }}
                    >
                      {toLocalTime(row.createdOn)}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "150px 10px 1fr",
                      gap: 1,
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#000",
                      }}
                    >
                      Discount details
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#000",
                      }}
                    >
                      :
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#000",
                      }}
                    >
                      {row.discountDetails}
                    </Typography>
                  </Box>

                  <>
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "150px 10px 1fr",
                        gap: 1,
                        alignItems: "start",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#000",
                        }}
                      >
                        Description
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#000",
                        }}
                      >
                        :
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#000",
                        }}
                      >
                        {row.description}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "150px 10px 1fr",
                        gap: 1,
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#000",
                        }}
                      >
                        Target
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#000",
                        }}
                      >
                        :
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#000",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "14px",
                            color: "#000",
                          }}
                        >
                          {JSON.parse(row.validFor).map((v, index, array) =>
                            index === array.length - 1 ? v : v + ", "
                          )}
                        </Typography>
                      </Typography>
                    </Box>
                  </>
                </Box>
                <Box sx={{ marginRight: "40px" }}>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#000",
                    }}
                  >
                    Terms and conditions
                  </Typography>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: row.termCondition || row.offerDetails,
                    }}
                  />
                </Box>
              </Box>
            );
          }}
        />
      </Box>
      {openRegularOfferModal && selectedRow && (
        <RegularOfferModal
          open={openRegularOfferModal}
          archived={selectedRow.archived}
          onSubmit={handleOfferSubmit}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
}
